import { HHStack, HHTypography } from '@hinge-health/react-component-library';

export const CalculationStep = ({
  value,
  description,
}: {
  value: string;
  description: string;
}): JSX.Element => (
  <HHStack alignItems="center" spacing={1}>
    <HHTypography hhVariant="body2" sx={{ fontWeight: 'medium' }}>
      {value}
    </HHTypography>
    <HHTypography hhVariant="caption" color="textSecondary">
      {description}
    </HHTypography>
  </HHStack>
);

export const Operator = ({ symbol }: { symbol: string }): JSX.Element => (
  <HHStack px={2}>
    <HHTypography hhVariant="body2" sx={{ fontWeight: 'medium' }}>
      {symbol}
    </HHTypography>
  </HHStack>
);
